import { FC, useState } from 'react'
import { Tabs, TabsControls, TabsContent } from '@wellesley/ui'

import About from '../About'
import Contacts from '../Contacts'
import ServerRules from '../ServerRules'
import BlockedDomains from '../BlockedDomains'
import {
  AboutServerTabsContainerSkeleton,
  AboutServerTabsSkeleton,
} from './LoaderSkeleton'

import { AboutServerSectionProps } from '../../types'

export const AboutServerTabs: FC<
  Pick<
    AboutServerSectionProps,
    | 'stats'
    | 'contacts'
    | 'description'
    | 'isLoading'
    | 'serverRules'
    | 'showBlockedDomainsTab'
    | 'showBlockedDomainsReason'
  >
> = ({
  stats,
  contacts,
  description,
  isLoading,
  serverRules,
  showBlockedDomainsTab,
  showBlockedDomainsReason,
}) => {
  const [activeTab, setActiveTab] = useState<string>('about')

  if (isLoading)
    return (
      <AboutServerTabsContainerSkeleton>
        <AboutServerTabsSkeleton />
      </AboutServerTabsContainerSkeleton>
    )

  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
      <TabsControls
        className="sticky top-0 z-10 bg-white"
        items={[
          {
            value: 'about',
            label: 'About server',
          },
          {
            value: 'rules',
            label: 'Rules',
          },
          ...(showBlockedDomainsTab
            ? [
                {
                  value: 'blocked-domains',
                  label: 'Blocked domains',
                },
              ]
            : []),
          {
            value: 'contacts',
            label: 'Contacts',
          },
        ]}
      />
      <div className="flex-1 px-m py-s">
        <TabsContent value="about">
          <About description={description} stats={stats} />
        </TabsContent>
        <TabsContent value="rules">
          <ServerRules serverRules={serverRules} />
        </TabsContent>
        <TabsContent value="blocked-domains">
          <BlockedDomains showBlockedDomainsReason={showBlockedDomainsReason} />
        </TabsContent>
        <TabsContent value="contacts">
          <Contacts contacts={contacts} />
        </TabsContent>
      </div>
    </Tabs>
  )
}
